import React, { useEffect, useState } from 'react'
import { Mention, MentionsInput } from 'react-mentions'
import { addInterfaceDetails, getCCTVType, getDeviceTypeOnInterfaceId, getInterfaceSubTypeData, getInterfaceTypeData, updateInterfaceDetails } from '../../../services/configurationServices'
import { useForm } from 'react-hook-form';
import { HIDE_STUFF, MULTI_TIME_ZONE } from '../../../config';
import { GetNewmultiTimeZone } from '../../../services/multiTimeZoneService';
import { ErrorToast } from '../../../CustomHooks/ErrorToast';
import { SuccessToast } from '../../../CustomHooks/SuccessToast';
import { useDeviceType } from '../../../CustomHooks/useDeviceType';

const InterfaceAdditionForm = ({ setShowAddSite, showAddSite, fetchFilters, selectedCustomer, handleApplyFilters, selectedRow, filterValues }) => {
    let interfaceObj = {
        siteid: 0,
        InterfaceId: 0,
        InterfaceName: "",
        InterfaceType: 0,
        InterfaceSubType: 0,
        InterfaceIP: "",
        InterfacePort: "",
        InterfaceUsername: "",
        InterfacePassword: "",
        UserId: 0,
        EntityTypeID: 0,
        InterfaceTwoWayEnabled: 0,
        PlaybackTimeStampsToUTC: 0,
        PlaybackLongDateFormat: 0,
        CheckInternalHooter: 0,
        CheckExternalHooter: 0,
        IsHooterEnabled: 0,
        LiveRTSPURL: "",
        PlaybackRTSPURL: "",
        CCTVType: "",
        TimeZoneId: 0,
        deviceTypeId: 0,
        communicationPort: "",
        httpPort: "",
        SerialNo:""
    };
    const NVRDVR = "NVRDVR";
    const PANEL = "PANEL";
    const FAS = "Fire Panel";
    const MOBILE = "MOBILE";
    const ACS = "ACS";
    const RTU = "RTU";
    const [interfaceTypeData, setInterfaceTypeData] = useState(null);
    const [mobileDisplay, setMobileDisplay] = useState(false);
    const [interfaceError, setInterfaceError] = useState('');
    const [serialNoError,setSerialNoError]= useState('');
    const [interfaceTypeError, setInterfaceTypeError] = useState('')
    const [interfaceSubTypeData, setInterfaceSubTypeData] = useState([]);
    const [interfaceType, setInterfaceType] = useState(NVRDVR);
    const [selectedInterface, setSelectedInterface] = useState(interfaceObj);
    const [displayTwoWay, setDisplayTwoWay] = useState(false);
    const [enableHooter, setEnableHooter] = useState(false);
    const [displayEntity, setDisplayEntity] = useState(false);
    const [displayCamera, setDisplayCamera] = useState(false);
    const [displayLivePlaybackfield, setDisplayLivePlaybackfield] = useState(false);
    const [interfaceSubtypeError, setInterfaceSubtypeError] = useState('')
    const [deviceTypeData, setDeviceTypeData] = useState([]);
    const [deviceTypeDataForInterface, setDeviceTypeDataForInterface] = useState([])
    const [interfaceDeviceTypeError, setInterfaceDeviceTypeError] = useState('')
    const [parentIsEnablingInternalHooter, setParentIsEnablingInternalHooter] =
        useState(false);
    const [parentIsEnablingExternalHooter, setParentIsEnablingExternalHooter] =
        useState(false);
    const [parentPanelIsEnablingHooter, setParentPanelIsEnablingHooter] =
        useState(false);
    const [isInterfaceEdit, setIsInterfaceEdit] = useState(true);
    const [parentIsEnablingPlaybackLongDateFormat, setParentIsEnablingPlaybackLongDateFormat] = useState(false);
    const [interfaceIPError, setInterfaceIPError] = useState('')

    const [interfacePortError, setInterfacePortError] = useState('')
    const [interfaceUserError, setInterfaceUserError] = useState('')
    const [interfacePasswardError, setInterfacePasswardError] = useState('')
    const [communicationPortError, setCommunicationPortError] = useState('');
    const [httpPortError, setHttpPotError] = useState('');
    const [interfaceTimeZoneError, setInterfaceTimeZoneError] = useState('')
    const [timezone, setTimeZone] = useState([]);
    const [rtspValue, setRtspValue] = useState("");
    const [playbackValue, setPlaybackValue] = useState("");
    const [rtspValueEntered, setRtspValueEntered] = useState("");
    const [playbackValueEntered, setPlaybackValueEntered] = useState("");
    const [liveStreamFormatError, setLiveStreamFormatError] = useState('');
    const [playbackStreamFormatError, setPlaybackStreamFormatError] = useState('');
    const [parentIsEnablingPlaybackTimeStampsToUTC, setParentIsEnablingPlaybackTimeStampsToUTC] = useState(false);
    const [parentIsEnablingTwoWayInterface, setParentIsEnablingTwoWayInterface] =
        useState(false);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [inputValidationError, setInputValidationError] = useState('');
    const [savebtnClick, setSavebtnClick] = useState(false);
    const [bulkUpload, setBulkUpload] = useState(false);
    const { deviceType, panelDeviceTypeOptions, getDataAfterInterface } = useDeviceType()
    const [disabledEntity, setDisabledEntity] = useState(false);
    const [cctvTypeData, setCctvTypeData] = useState(null);


    const {
        register,
        handleSubmit,
        getValues,
        setValue,
        watch,
        formState: { isDirty, touchedFields },
    } = useForm({ defaultValue: { ...selectedInterface } });

    useEffect(() => {
        console.log("UseEffect - selectedInterface", selectedInterface)
        getDeviceTypeByInterfaceId(selectedInterface?.InterfacetypeId)
        setValue("InterfaceName", selectedInterface.InterfaceName);
        //setValue("InterfaceType", "CCTV");Interfacetypename
        if (selectedInterface?.Interfacetypename == "Mobile" || selectedInterface.InterfacetypeId == "Mobile" || selectedInterface.InterfaceType == "Mobile") {
            setMobileDisplay(true)
        } else {
            setMobileDisplay(false)
        }
        setValue("InterfaceType", selectedInterface.Interfacetypename || selectedInterface.InterfacetypeId || selectedInterface.InterfaceType);
        setValue("InterfaceSubType", selectedInterface.Interfacesubtypename || selectedInterface.InterfacesubtypeId || selectedInterface.InterfaceSubType);
        setValue("EntityTypeID", selectedInterface.EntityTypeID || selectedInterface.InterfaceType);
        setValue("deviceTypeId", selectedInterface.EntityTypeID || selectedInterface.InterfaceType);
        setValue("InterfaceIP", selectedInterface.InterfaceIP);
        setValue("TimeZoneId", selectedInterface.TimeZoneID || selectedInterface.TimeZoneId);
        setValue("InterfacePort", selectedInterface.InterfacePort);
        setValue("communicationPortInterface", selectedInterface.Communicationport || selectedInterface.communicationPortInterface || selectedInterface.communicationPort)
        setValue("httpPortInterface", selectedInterface.InternetProtocolPort || selectedInterface.httpPortInterface || selectedInterface.httpPort)
        setValue("InterfaceUsername", selectedInterface.UserName);
        setValue("InterfacePassword", selectedInterface.Password);
        setValue("LiveRTSPURL", selectedInterface.LiveRTSPURL);
        setRtspValueEntered(selectedInterface.LiveRTSPURL)
        setRtspValue(selectedInterface.LiveRTSPURL == null ? "" : selectedInterface.LiveRTSPURL)
        setValue("PlaybackRTSPURL", selectedInterface.PlaybackRTSPURL);
        setPlaybackValue(selectedInterface.PlaybackRTSPURL == null ? "" : selectedInterface.PlaybackRTSPURL)
        setPlaybackValueEntered(selectedInterface.PlaybackRTSPURL)
        setValue("", selectedInterface.InterfaceId);
        setValue("CCTVTypeIDInterface", selectedInterface.CCTVTypeIDInterface);
        setValue("CCTVType", selectedInterface.CCTVType);
        setValue("SerialNo",selectedInterface.SerialNo)
        if (selectedInterface.isTwoWayEnabled || selectedInterface.IsTwoWayEnabled == "1") {
            setValue("InterfaceTwoWayEnabled", 1)
            setParentIsEnablingTwoWayInterface(true);
        } else {
            setValue("InterfaceTwoWayEnabled", 0)
            setParentIsEnablingTwoWayInterface(false);
        }

        if (selectedInterface.CheckPlaybackUTCTime == "1" || selectedInterface.CheckPlaybackUTCTime == true) {
            setValue("PlaybackTimeStampsToUTC", 1)
            setParentIsEnablingPlaybackTimeStampsToUTC(true);
        } else {
            setValue("PlaybackTimeStampsToUTC", 0)
            setParentIsEnablingPlaybackTimeStampsToUTC(false);
        }

        if (selectedInterface.CheckPlaybackLongTime == "1" || selectedInterface.CheckPlaybackLongTime == true) {
            setValue("PlaybackLongDateFormat", 1)
            setParentIsEnablingPlaybackLongDateFormat(true);
        } else {
            setValue("PlaybackLongDateFormat", 0)
            setParentIsEnablingPlaybackLongDateFormat(false);
        }

        if (selectedInterface.CheckInternalHooter == true || selectedInterface.CheckInternalHooter == "1") {
            setValue("CheckInternalHooter", 1)
            setParentIsEnablingInternalHooter(true);
        } else {
            setValue("CheckInternalHooter", 0)
            setParentIsEnablingInternalHooter(false);
        }

        if (selectedInterface.CheckExternalHooter == true || selectedInterface.CheckExternalHooter == "1") {
            setValue("CheckExternalHooter", 1)
            setParentIsEnablingExternalHooter(true);
        } else {
            setValue("CheckExternalHooter", 0)
            setParentIsEnablingExternalHooter(false);
        }

        if (selectedInterface.isHooterEnabled == true || selectedInterface.IsHooterEnabled == true || selectedInterface.IsHooterEnabled == "1") {
            setValue("IsHooterEnabled", 1)
            setParentPanelIsEnablingHooter(true);
        } else {
            setValue("IsHooterEnabled", 0)
            setParentPanelIsEnablingHooter(false);
        }


        if (selectedInterface.InterfaceId == 0) {
            setEnableHooter(false)
            setDisplayCamera(false)
            setDisplayLivePlaybackfield(false)
            setDisabledEntity(false)
        }
        else {
            setDisabledEntity(true)
        }
        if (selectedInterface.InterfaceType == 0 || selectedInterface.Interfacetypename == "CCTV") {
            setInterfaceType(NVRDVR);
            setBulkUpload(false);
        } else if (selectedInterface.Interfacetypename == "Alarm Panel") {
            setInterfaceType(PANEL);
            setBulkUpload(false);
        } else if (selectedInterface.Interfacetypename == "ACS") {
            setInterfaceType(ACS);
            setBulkUpload(false);
        } else if ((selectedInterface.Interfacetypename == "Fire Panel")) {
            setInterfaceType(FAS)
            setBulkUpload(false)
        } else if ((selectedInterface.Interfacetypename == "RTU")) {
            setInterfaceType(RTU)
            setBulkUpload(false)
        }
        else if ((selectedInterface.Interfacetypename == "Mobile")) {
            setInterfaceType(MOBILE)
            setBulkUpload(false)
        }

        let tempDeviceType = deviceType.find((item) => item.DeviceTypeID == selectedInterface.EntityTypeID);
        if (selectedInterface.CCTVType == "Camera" || tempDeviceType?.DeviceType == "Camera") {
            if (selectedInterface.Interfacesubtypename == "Unknown") {
                setDisplayCamera(false)
                setEnableHooter(false)
            } else {
                setDisplayCamera(true)
                setEnableHooter(false)
            }
        } else if (selectedInterface.Interfacetypename == "Alarm Panel") {
            setDisplayCamera(false)
            setEnableHooter(true)
        }
        else if (selectedInterface.Interfacetypename == "ACS") {
            setDisplayCamera(false)
            setEnableHooter(false)
        } else if (selectedInterface.Interfacetypename == "Fire Panel") {
            setDisplayCamera(false)
            setEnableHooter(false)
        } else if (selectedInterface.Interfacetypename == "RTU") {
            setDisplayCamera(false)
            setEnableHooter(false)
        }
        else if (selectedInterface.Interfacesubtypename == "Unknown") {
            setDisplayCamera(false)
            setEnableHooter(false)
        }
        else {
            setDisplayCamera(false)
            setEnableHooter(true)
        }

        if (selectedInterface.Interfacetypename == "CCTV") {
            if (selectedInterface.Interfacesubtypename == "Unknown") {
                setDisplayTwoWay(false);
                setDisplayEntity(true);
            } else {
                setDisplayTwoWay(true);
                setDisplayEntity(true);
            }
        } else {
            setDisplayTwoWay(false);
            setDisplayEntity(false);
        }
    }, [selectedInterface, deviceType])

    useEffect(() => {
        if (selectedRow) {
            setSelectedInterface(selectedRow)
        }
    }, [selectedRow]);

    useEffect(() => {
        console.log("UseEffect - selectedInterface", selectedInterface)
        setValue("InterfaceSubType", selectedInterface.Interfacesubtypename || selectedInterface.InterfacesubtypeId || selectedInterface.InterfaceSubType);
        // this is for demo/unknown
        if (selectedInterface.Interfacesubtypename == "Unknown") {
            setDisplayLivePlaybackfield(true);
        } else {
            setDisplayLivePlaybackfield(false);
        }
    }, [interfaceSubTypeData, selectedInterface])

    useEffect(() => {
        console.log("UseEffect - selectedInterface", selectedInterface)
        console.log("UseEffect - selectedInterface", deviceTypeDataForInterface)
        setValue("deviceTypeId", selectedInterface.EntityTypeID || selectedInterface.InterfaceType);
    }, [deviceTypeDataForInterface])

    useEffect(() => {
        console.log("UseEffect - selectedInterface", selectedInterface)
        setValue("EntitySubtype", selectedInterface.EntitySubtype || selectedInterface.InterfaceType);
    }, [cctvTypeData])

    useEffect(() => {
        console.log("UseEffect - selectedInterface", selectedInterface)
        setValue("TimeZoneId", selectedInterface.TimeZoneID || selectedInterface.TimeZoneId);
    }, [timezone])

    useEffect(() => {
        console.log("UseEffect - selectedInterface", selectedInterface)
        setValue("InterfaceType", selectedInterface.Interfacetypename || selectedInterface.InterfacetypeId || selectedInterface.InterfaceType);
        getDeviceTypeByInterfaceId(selectedInterface?.InterfacetypeId)
    }, [interfaceTypeData])


    useEffect(() => {
        if (savebtnClick) {
            let templst = inputValidationError.split(",");
            for (let i = 0; i < templst.length; i++) {
                if (templst[i]?.includes("interface-")) {
                    setInterfaceError(templst[i]?.replace("interface-", ""));
                    continue
                }

                if (templst[i]?.includes("system-")) {
                    setInterfaceTypeError(templst[i]?.replace("system-", ""));
                    continue
                }

                if (templst[i]?.includes("brand-")) {
                    setInterfaceSubtypeError(templst[i]?.replace("brand-", ""));
                    continue
                }
                if (templst[i]?.includes("interface timezone-")) {
                    setInterfaceTimeZoneError(templst[i]?.replace("interface timezone-", ""));
                    continue
                }

                if (templst[i]?.includes("interface devicetype-")) {
                    setInterfaceDeviceTypeError(templst[i]?.replace("interface devicetype-", ""));
                    continue
                }


                if (templst[i]?.includes("interface IP-")) {
                    setInterfaceIPError(templst[i]?.replace("interface IP-", ""));
                    continue
                }

                if (templst[i]?.includes("interface port-")) {
                    setInterfacePortError(templst[i]?.replace("interface port-", ""));
                    continue
                }
                if (templst[i]?.includes("communication port-")) {
                    setCommunicationPortError(templst[i]?.replace("communication port-", ""));
                    continue
                }

                if (templst[i]?.includes("http port-")) {
                    setHttpPotError(templst[i]?.replace("http port-", ""));
                    continue
                }

                if (templst[i]?.includes("interface username-")) {
                    setInterfaceUserError(templst[i]?.replace("interface username-", ""));
                    continue
                }

                if (templst[i]?.includes("interface password-")) {
                    setInterfacePasswardError(templst[i]?.replace("interface password-", ""));
                    continue
                }

                if (templst[i]?.includes("interface livestream format-")) {
                    setLiveStreamFormatError(templst[i]?.replace("interface livestream format-", ""));
                    continue
                }

                if (templst[i]?.includes("interface playbackstream format-")) {
                    setPlaybackStreamFormatError(templst[i]?.replace("interface playbackstream format-", ""));
                    continue
                }

                // if (templst[i]?.includes("interface serial no-")) {
                //     setSerialNoError(templst[i]?.replace("interface serial no-", ""));
                //     continue
                // }
            }
            setSavebtnClick(false)
        }
    }, [savebtnClick]);


    useEffect(() => {
        getInterfaceType();
        getInterfaceSubType();
        getNewTimeZoneList();
        getCCTVTypeMasterData();
    }, [])

    useEffect(() => {
        getInterfaceSubType(selectedInterface.InterfacetypeId);
    }, [selectedInterface]);

    const getCCTVTypeMasterData = () => {
        try {
            var obj = {
                type: "interfaceentitytype",
            };
            getCCTVType(obj).then((resp) => {
                if (resp != undefined) {
                    if (resp.Status == "success") {
                        setCctvTypeData(resp.Data);
                    } else {
                        setCctvTypeData(null);
                    }
                }
            });
        } catch (error) {
            console.error(error);
        }
    };
    const clearInterfaceFields = () => {

        setInterfaceError('');
        setInterfaceTypeError('');
        setInterfaceSubtypeError('');
        //setInterfaceEntitySubtypeError('');
        setInterfaceDeviceTypeError('')
        setInterfaceIPError('');
        setInterfacePortError('');
        setInterfaceUserError('');
        setInterfacePasswardError('');
        setLiveStreamFormatError('');
        setPlaybackStreamFormatError('');
        setInterfaceTimeZoneError('');
        setIsInterfaceEdit(false)
        setSelectedInterface(interfaceObj)
        //setSerialNoError('');
    }


    const getInterfaceType = () => {
        try {
            var obj = {
                "type": "interfacetypemaster"
            }
            getInterfaceTypeData(obj).then((resp) => {
                if (resp != undefined) {
                    if (resp.Status == "success") {
                        const filterMobile = resp.Data.filter(item => item.Interfacetypename !== "Mobile");
                        setInterfaceTypeData(filterMobile);
                    } else {
                        setInterfaceTypeData(null)
                    }
                }
            })
        } catch (error) {
            console.error(error)
        }
    }
    const getInterfaceSubType = (interfaceType) => {
        try {
            let obj = {
                type: "interfacesubtypemaster",
                parameters: {
                    InterfacetypeId: interfaceType,
                },
            };
            if (interfaceType != undefined) {
                getInterfaceSubTypeData(obj).then((resp) => {
                    if (resp != undefined) {
                        if (resp.Status == "success") {
                            setInterfaceSubTypeData(resp.Data);
                        } else {
                            setInterfaceSubTypeData(null);
                        }
                    }
                });
            }
        } catch (error) {
            console.error(error);
        }
    };
    const interfaceSubTypeHandler = (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const selectedInterfaceType = selectedOption.value;
        const selectedInterfaceTypeId = selectedOption.getAttribute('id');
        try {
            let obj = {
                "type": "interfacesubtypemaster",
                "parameters": {
                    "InterfacetypeId": selectedInterfaceTypeId
                }
            }
            getInterfaceSubTypeData(obj).then((resp) => {
                if (resp != undefined) {
                    if (resp.Status == "success") {
                        let CCTV = interfaceTypeData?.find((item) => item.Interfacetypename == "CCTV")
                        let ACS = interfaceTypeData?.find((item) => item.Interfacetypename == "ACS")
                        let RTU = interfaceTypeData?.find((item) => item.Interfacetypename == "RTU")
                        let FirePanel = interfaceTypeData?.find((item) => item.Interfacetypename == "Fire Panel")
                        let Mobile = interfaceTypeData?.find((item) => item.Interfacetypename == "Mobile")
                        setInterfaceSubTypeData(resp.Data)
                        if (selectedInterfaceTypeId == CCTV?.InterfacetypeId) {
                            setInterfaceType(NVRDVR)
                            setDisplayTwoWay(true)
                            // setDisplayHooter(false)
                            setEnableHooter(false)
                            setValue("CCTVTypeIDInterface", 0);
                            setDisplayEntity(true)
                        }
                        else if (selectedInterfaceTypeId == ACS?.InterfacetypeId) {
                            setInterfaceType(ACS);
                            setDisplayTwoWay(false)
                            setDisplayCamera(false)
                            setEnableHooter(false);
                            setDisplayEntity(false);
                        }
                        else if (selectedInterfaceTypeId == FirePanel?.InterfacetypeId) {
                            setInterfaceType(FAS);
                            setDisplayTwoWay(false)
                            setDisplayCamera(false)
                            setEnableHooter(false);
                            setDisplayEntity(false);
                        }
                        else if (selectedInterfaceTypeId == RTU?.InterfacetypeId) {
                            setInterfaceType(RTU);
                            setDisplayTwoWay(false)
                            setDisplayCamera(false)
                            setEnableHooter(false);
                            setDisplayEntity(false);
                        }
                        else if (selectedInterfaceTypeId == Mobile?.InterfacetypeId) {
                            setInterfaceType(MOBILE);
                            setDisplayTwoWay(false)
                            setDisplayCamera(false)
                            setEnableHooter(false);
                            setDisplayEntity(false);
                        }
                        else {
                            setInterfaceType(PANEL)
                            setDisplayTwoWay(false)
                            setDisplayCamera(false)
                            //setDisplayHooter(true)
                            setEnableHooter(true)
                            setDisplayEntity(false);
                        }
                    } else {
                        setInterfaceSubTypeData(null)
                    }
                }
            })
        } catch (error) {
            console.error(error)
        }
    }
    const interfaceForDeviceTypeHandler = (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const selectedInterfaceTypeId = selectedOption.getAttribute('id');
        getDeviceTypeByInterfaceId(selectedInterfaceTypeId)
    }
    const getDeviceTypeByInterfaceId = (id) => {

        getDeviceTypeOnInterfaceId(id)
            .then((res) => {
                console.log("UseEffect - selectedInterface", id)
                if (res.Status == "success") {
                    console.log("UseEffect - selectedInterface", res.Data)
                    console.log("UseEffect - selectedInterface", interfaceTypeData)
                    let deviceType = interfaceTypeData.find((item) =>
                        item.InterfacetypeId == id
                    )
                    if (deviceType?.Interfacetypename == "Alarm Panel") {
                        setDeviceTypeData(res.Data)
                        let arr = res.Data?.filter(
                            (item) => item.DeviceType == "IDS Panel"
                        );
                        setDeviceTypeDataForInterface(arr)
                    }
                    else if (deviceType?.Interfacetypename == "ACS") {
                        setDeviceTypeData(res.Data)
                        let arr = res.Data?.filter(
                            (item) => item.DeviceType == "ACS Controller"
                        );
                        setDeviceTypeDataForInterface(arr)
                    } else if (deviceType?.Interfacetypename == "Fire Panel") {
                        let arrFRSDevice = res.Data?.filter(
                            (item) => item.DeviceType != "Fire Panel"
                        );
                        setDeviceTypeData(arrFRSDevice)
                        let arrFRS = res.Data?.filter(
                            (item) => item.DeviceType == "Fire Panel"
                        );
                        setDeviceTypeDataForInterface(arrFRS)

                    } else if (deviceType?.Interfacetypename == "RTU") {
                        let arrRTUDevice = res.Data?.filter(
                            (item) => item.DeviceType != "RTU"
                        );
                        setDeviceTypeData(arrRTUDevice)
                        let arrRTU = res.Data?.filter(
                            (item) => item.DeviceType == "RTU"
                        );
                        setDeviceTypeDataForInterface(arrRTU)
                    }
                    else {
                        console.log("UseEffect - selectedInterface", res.Data)
                        setDeviceTypeData(res.Data)
                        setDeviceTypeDataForInterface(res.Data)
                    }
                } else {
                    setDeviceTypeData([])
                    setDeviceTypeDataForInterface([])
                }
            }).catch(err => console.log(err))
    }
    const onSpecialChangeOnly = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const isValid = new RegExp("^[A-Za-z0-9.\\-_ ]*$").test(keyValue);
        if (!isValid) {
            event.preventDefault();
            return;
        }
    }
    const onNumberOnlyChange2 = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const isValid = new RegExp("[0-9.]").test(keyValue);
        if (!isValid) {
            event.preventDefault();
            return;
        }
    };
    const onNumberOnlyChange = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const isValid = new RegExp("[0-9]").test(keyValue);
        if (!isValid) {
            event.preventDefault();
            return;
        }
    };
    const getNewTimeZoneList = () => {
        try {
            var obj = {
                type: "TimeZone",
            };
            GetNewmultiTimeZone(obj).then((resp) => {
                if (resp != undefined) {
                    if (resp.Status == "success") {
                        setTimeZone(resp.Data);
                    } else {
                        setTimeZone(null);
                    }
                }
            });
        } catch (error) {
            console.error(error);
        }
    };
    const RTSP = [
        {
            id: "Username",
            display: "[Username]",
        },
        {
            id: "Password",
            display: "[Password]",
        },
        {
            id: "IpAddress",
            display: "[IpAddress]",
        },
        {
            id: "Port",
            display: "[Port]",
        },
        {
            id: "ChannelNo",
            display: "[ChannelNo]",
        },
        {
            id: "LiveStreamType",
            display: "[LiveStreamType]",
        },
    ];

    const PLAYBACK = [
        {
            id: "Username",
            display: "[Username]",
        },
        {
            id: "Password",
            display: "[Password]",
        },
        {
            id: "IpAddress",
            display: "[IpAddress]",
        },
        {
            id: "Port",
            display: "[Port]",
        },
        {
            id: "ChannelNo",
            display: "[ChannelNo]",
        },
        {
            id: "PlaybackStreamType",
            display: "[PlaybackStreamType]",
        },
        
        {
            id: "DateDD",
            display: "[DD]",
        },
        {
            id: "DateMM",
            display: "[MM]",
        },
        {
            id: "DateYY",
            display: "[YY]",
        },
        {
            id: "DateYYYY",
            display: "[YYYY]",
        },
        {
            id: "HoursHH",
            display: "[hh]",
        },
        {
            id: "MinutesMM",
            display: "[mm]",
        },
        {
            id: "SecondsSS",
            display: "[ss]",
        },
    ];
    const onInterfaceFormSubmit = async (
        interfaceDetailsData,
        id,
        rtspValueEntered,
        playbackValueEntered
    ) => {
        console.log("onInterfaceFormSubmit", rtspValueEntered)
        console.log("onInterfaceFormSubmit", playbackValueEntered)
        setButtonDisable(true);
        let interfaceTwoWayEnabled;
        let playbackTimeStampsToUTCEnabled;
        let playbackLongDateFormatEnabled;
        if (parentIsEnablingTwoWayInterface) {
            interfaceTwoWayEnabled = "1";
        } else {
            interfaceTwoWayEnabled = "0";
        }
        let interfaceInternalHooter;
        if (parentIsEnablingInternalHooter) {
            interfaceInternalHooter = "1";
        } else {
            interfaceInternalHooter = "0";
        }

        let interfaceExternalHooter;
        if (parentIsEnablingExternalHooter) {
            interfaceExternalHooter = "1";
        } else {
            interfaceExternalHooter = "0";
        }

        let interfacePanelEnableHooter;
        console.log("FourteenthDec", parentPanelIsEnablingHooter);
        if (parentPanelIsEnablingHooter) {
            interfacePanelEnableHooter = "1";
        } else {
            interfacePanelEnableHooter = "0";
        }
        console.log("UTCIssue", parentIsEnablingPlaybackTimeStampsToUTC)
        if (parentIsEnablingPlaybackTimeStampsToUTC) {
            playbackTimeStampsToUTCEnabled = "1";
        } else {
            playbackTimeStampsToUTCEnabled = "0";
        }
        console.log("UTCIssue", parentIsEnablingPlaybackLongDateFormat)
        if (parentIsEnablingPlaybackLongDateFormat) {
            playbackLongDateFormatEnabled = "1";
        } else {
            playbackLongDateFormatEnabled = "0";
        }
        console.log("SAVEINTERFACE", interfaceDetailsData)
        let interfaceName = interfaceDetailsData.InterfaceName;
        let interfaceType = interfaceDetailsData.InterfaceType;
        let interfaceTypeId = interfaceDetailsData.InterfaceTypeId;
        let deviceTypeId = interfaceDetailsData.deviceTypeId
        let interfaceSubType = interfaceDetailsData.InterfaceSubType;
        let interfaceSubtTypeId = interfaceDetailsData.InterfaceSubTypeId;
        let interfaceEntitySubType = interfaceDetailsData.EntityTypeID;
        let interfaceIP = interfaceDetailsData.InterfaceIP;
        let interfacePort = interfaceDetailsData.InterfacePort;
        let interfaceUsername = interfaceDetailsData.InterfaceUsername;
        let interfacePassword = interfaceDetailsData.InterfacePassword;
        let liveStreamURL = rtspValueEntered ?? "";
        let playbackStreamURL = playbackValueEntered ?? "";
        let UserId = localStorage.getItem("UserID");
        let interfaceTimeZoneId = interfaceDetailsData.TimeZoneId;
        let user = JSON.parse(localStorage.getItem("user"));
        let communicationPort = interfaceDetailsData.communicationPortInterface;
        let httpPort = interfaceDetailsData.httpPortInterface
        let validationError = "";
        let SerialNo = interfaceDetailsData.SerialNo

        if (interfaceName === "" || interfaceName == null || interfaceName === 0) {
            validationError += "interface-Please enter interface name!,";
        }
        if (
            interfaceType === "" ||
            interfaceType == null ||
            interfaceType == 0 ||
            interfaceType == undefined
        ) {
            validationError += "system-Please select system!,";
        }

        if (
            interfaceSubType === "" ||
            interfaceSubType == null ||
            interfaceSubType == 0 ||
            interfaceSubType == undefined
        ) {
            validationError +=
                "brand-Please select brand type!,";
        }

        if (deviceTypeId == 0 || deviceTypeId == "" || deviceTypeId == null || deviceTypeId == undefined) {
            validationError +=
                "interface devicetype-Please select interface!,";
        }

        // Commenting the below due to deviceType addition.
        // if (interfaceType !== "Alarm Panel" && interfaceType !== "ACS") {
        //   if (
        //     interfaceEntitySubType == undefined ||
        //     interfaceEntitySubType == "" ||
        //     interfaceEntitySubType == 0 ||
        //     interfaceEntitySubType == "Entity Subtype*"
        //   ) {
        //     // showErrorToast('Please select entity subtype!');
        //     // return;
        //     validationError +=
        //       "interface entity subtype-Please select entity subtype!,";
        //   }
        // }
        if (!mobileDisplay) {
            if (interfaceIP === "" || interfaceIP === undefined) {
                validationError += "interface IP-Please enter interface IP!,";
            } else {
                const pattern =
                    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

                if (pattern.test(interfaceIP) == false) {
                    validationError += "interface IP-Please enter Valid interface IP!,";
                }
            }
        }
        if (!mobileDisplay) {
            if (interfacePort === "" || interfacePort === undefined) {
                validationError += "interface port-Please enter interface port!,";
            }
        }

        if (!mobileDisplay) {
            if (interfaceType == "CCTV") {
                if (
                    communicationPort === undefined ||
                    communicationPort === null ||
                    communicationPort === ""
                ) {
                    validationError += "communication port-Please enter communication port!,";
                }
            }
        }


        if (!mobileDisplay) {
            if (interfaceType == "CCTV") {
                if (httpPort === undefined || httpPort === null || httpPort === "") {
                    validationError += "http port-Please enter Http port!,";
                }
            }
        }

        if (!mobileDisplay) {
            if (interfaceUsername === "" || interfaceUsername === undefined) {
                validationError += "interface username-Please enter interface username!,";
            }
        }

        if (!mobileDisplay) {
            if (interfacePassword === "" || interfacePassword === undefined) {
                validationError += "interface password-Please enter interface password!,";
            }
        }

        if (MULTI_TIME_ZONE) {
            if (interfaceTimeZoneId == undefined || interfaceTimeZoneId == 0) {
                validationError += "interface timezone-Please select timezone!,";
            }
        }
        if (!mobileDisplay) {
            if (
                (interfaceSubType == "Unknown" && liveStreamURL === "") ||
                (interfaceSubType == "Unknown" && liveStreamURL === undefined)
            ) {
                validationError +=
                    "interface livestream format-Please enter live stream url!,";
            }
        }

        if (!mobileDisplay) {
            if (
                (interfaceSubType == "Unknown" && playbackStreamURL === "") ||
                (interfaceSubType == "Unknown" && playbackStreamURL === undefined)
            ) {
                validationError +=
                    "interface playbackstream format-Please enter playback stream url!,";
            }
        }
        // if (SerialNo === "" || SerialNo == null || SerialNo === 0) {
        //     validationError += "interface serial no-Please enter serial no!,";
        // }

        setInputValidationError(validationError);
        setSavebtnClick(true);
        if (validationError != "") {
            setButtonDisable(false);
            return;
        }

        let tempInterfaceType = interfaceTypeData.filter((item) => {
            return item.Interfacetypename === interfaceType;
        });

        let tempInterfaceSubType = interfaceSubTypeData.filter((item) => {
            return item.Interfacesubtypename == interfaceSubType;
        });

        // let entitySubType = "";
        // if (interfaceType !== "Alarm Panel" && interfaceType !== "ACS") {
        //   let tempEntitySubType = cctvTypeData.filter((item) => {
        //     return item.EntityTypeID == interfaceEntitySubType;
        //   });
        //   entitySubType = tempEntitySubType[0].EntityTypeID;
        // }

        let tempArr = deviceTypeDataForInterface.filter((item) => {
            return item.DeviceTypeID == deviceTypeId
        })
        let deviceTypeName = tempArr[0].DeviceType;
        if (interfaceType == "CCTV" && deviceTypeName == "Camera") {
            if (interfaceInternalHooter == "0" && interfaceExternalHooter == "0") {
                interfacePanelEnableHooter = "0";
            } else {
                interfacePanelEnableHooter = "1";
            }
        }
        // let EntityTypeIDCheck 
        // if (interfaceType == "CCTV") {
        //   EntityTypeIDCheck = entitySubType
        // }
        // else {
        //   EntityTypeIDCheck = null
        // }
        if (id === 0) {
            // let addUpdateInterfaceDetailsObj = {
            //     "InterfaceName": interfaceName,
            //     "InterfacetypeId": tempInterfaceType[0].InterfacetypeId,
            //     "InterfacesubtypeId": tempInterfaceSubType[0].InterfacesubtypeId,
            //     "InterfaceIP": interfaceIP,
            //     "InterfacePort": interfacePort,
            //     "UserName": interfaceUsername,
            //     "Password": interfacePassword,
            //     "siteid": selectedSite.SiteID,
            //     "Interfacetypename": interfaceType,
            //     "Interfacesubtypename": interfaceSubType,
            //     "UserId": UserId,
            //     "IsTwoWayEnabled": interfaceTwoWayEnabled,
            //     "CheckInternalHooter": interfaceInternalHooter,
            //     "CheckExternalHooter":interfaceExternalHooter,
            //     "IsHooterEnabled":interfacePanelEnableHooter,
            //     "CheckPlaybackUTCTime" : playbackTimeStampsToUTCEnabled,
            //     "CheckPlaybackLongTime":playbackLongDateFormatEnabled,
            //     "LiveRTSPURL": liveStreamURL,
            //     "PlaybackRTSPURL": playbackStreamURL,
            //     "EntityTypeID": entitySubType,
            //     "TimeZoneId": interfaceTimeZoneId
            // }
            console.log("selectedCustomer", selectedCustomer)
            let addInterfaceUAPIObj = {
                InterfaceName: interfaceName?.toString().trim(),
                InterfacetypeId: tempInterfaceType[0].InterfacetypeId,
                InterfacesubtypeId: tempInterfaceSubType[0].InterfacesubtypeId,
                InterfaceIP: interfaceIP,
                InterfacePort: interfacePort,
                UserName: interfaceUsername?.toString().trim(),
                Password: interfacePassword?.toString().trim(),
                siteid: filterValues.Site?.[0]?.value || null,
                isTwoWayEnabled: interfaceTwoWayEnabled,
                isHooterEnabled: interfacePanelEnableHooter,
                CheckInternalHooter: interfaceInternalHooter,
                CheckExternalHooter: interfaceExternalHooter,
                LiveRTSPURL: liveStreamURL,
                PlaybackRTSPURL: playbackStreamURL,
                CheckPlaybackUTCTime: playbackTimeStampsToUTCEnabled,
                CheckPlaybackLongTime: playbackLongDateFormatEnabled,
                // EntityTypeID: EntityTypeIDCheck,
                EntityTypeID: deviceTypeId,
                TimeZoneID: interfaceTimeZoneId,
                OrganizationMasterID: user.OrganizationMasterID.toString(),
                UpdatedateTime: "",
                Communicationport: communicationPort || 8000,
                InternetProtocolPort: httpPort || 80,
                UserId: user?.Id.toString(),
                SerialNo: SerialNo?.toString().trim(),
                UserID: user?.Id.toString()
            };
            addInterfaceDetails(addInterfaceUAPIObj).then((resp) => {
                if (resp.Status === "success") {
                    let tempEntitySubType;
                    let entitySubType = 0;
                    let entityValue = "";
                    // if (tempInterfaceType[0].InterfacetypeId == 1) {
                    //   tempEntitySubType = cctvTypeData.filter((item) => {
                    //     return item.EntityTypeID == interfaceEntitySubType;
                    //   });
                    //   entitySubType = tempEntitySubType[0].EntityTypeID;
                    //   entityValue = tempEntitySubType[0].EntityType;
                    // }
                    let tempInterfaceObj = {
                        InterfaceId: resp.Data.InterfaceId,
                        InterfaceName: interfaceName,
                        InterfacetypeId: tempInterfaceType[0].InterfacetypeId,
                        InterfacesubtypeId: tempInterfaceSubType[0].InterfacesubtypeId,
                        InterfaceIP: interfaceIP,
                        InterfacePort: interfacePort,
                        UserName: interfaceUsername,
                        Password: interfacePassword,
                        siteid: filterValues.Site?.[0]?.value || null,
                        Interfacetypename: interfaceType,
                        Interfacesubtypename: interfaceSubType,
                        UserId: UserId,
                        IsTwoWayEnabled: interfaceTwoWayEnabled,
                        CheckInternalHooter: interfaceInternalHooter,
                        CheckExternalHooter: interfaceExternalHooter,
                        IsHooterEnabled: interfacePanelEnableHooter,
                        CheckPlaybackUTCTime: playbackTimeStampsToUTCEnabled,
                        CheckPlaybackLongTime: playbackLongDateFormatEnabled,
                        LiveRTSPURL: liveStreamURL,
                        PlaybackRTSPURL: playbackStreamURL,
                        EntityTypeID: deviceTypeId,
                        CCTVType: entityValue,
                        TimeZoneId: interfaceTimeZoneId,
                        deviceTypeId: deviceTypeId,
                        communicationPortInterface: communicationPort || 8000,
                        httpPortInterface: httpPort || 80,
                        SerialNo:SerialNo,
                        UserID:user?.Id.toString()
                    };
                    fetchFilters();
                    handleApplyFilters()
                    setButtonDisable(false);
                    SuccessToast(resp.Message);
                    setSelectedInterface(tempInterfaceObj);
                    setIsInterfaceEdit(false);
                    setParentPanelIsEnablingHooter(false);
                    clearInterfaceFields();
                } else {
                    ErrorToast(resp.Message);
                    setButtonDisable(false);
                }
            });
        } else {
            let tempEntitySubType;
            let entitySubType = "";
            let entityValue = "";

            // if (tempInterfaceType[0].InterfacetypeId == 1) {
            //   tempEntitySubType = cctvTypeData.filter((item) => {
            //     return item.EntityTypeID == interfaceEntitySubType;
            //   });
            //   entitySubType = tempEntitySubType[0].EntityTypeID;
            //   entityValue = tempEntitySubType[0].EntityType;
            // }

            // let EntityTypeIDCheck 
            // if (interfaceType == "CCTV") {
            //   EntityTypeIDCheck = entitySubType
            // }
            // else {
            //   EntityTypeIDCheck = null
            // }

            // let addUpdateInterfaceDetailsObj = {
            //     "InterfaceId": id,
            //     "InterfaceName": interfaceName,
            //     "InterfacetypeId": tempInterfaceType[0].InterfacetypeId,
            //     "InterfacesubtypeId": tempInterfaceSubType[0].InterfacesubtypeId,
            //     "InterfaceIP": interfaceIP,
            //     "InterfacePort": interfacePort,
            //     "UserName": interfaceUsername,
            //     "Password": interfacePassword,
            //     "siteid": selectedSite.SiteID,
            //     "Interfacetypename": interfaceType,
            //     "Interfacesubtypename": interfaceSubType,
            //     "UserId": UserId,
            //     "IsTwoWayEnabled": interfaceTwoWayEnabled,
            //     "CheckInternalHooter": interfaceInternalHooter,
            //     "CheckExternalHooter":interfaceExternalHooter,
            //     "IsHooterEnabled":interfacePanelEnableHooter,
            //     // "IsTwoWayEnabled": interfaceTwoWayEnabled,
            //     "CheckPlaybackUTCTime" : playbackTimeStampsToUTCEnabled,
            //     "CheckPlaybackLongTime":playbackLongDateFormatEnabled,
            //     "LiveRTSPURL": liveStreamURL,
            //     "PlaybackRTSPURL": playbackStreamURL,
            //     "EntityTypeID":  entitySubType,
            //     "TimeZoneId": interfaceTimeZoneId
            // }
            let updateInterfaceUAPIObj = {
                InterfaceId: id.toString(),
                InterfaceName: interfaceName?.toString().trim(),
                InterfacetypeId: tempInterfaceType[0].InterfacetypeId,
                InterfacesubtypeId: tempInterfaceSubType[0].InterfacesubtypeId,
                InterfaceIP: interfaceIP,
                InterfacePort: interfacePort,
                UserName: interfaceUsername?.toString().trim(),
                Password: interfacePassword,
                siteid: filterValues.Site?.[0]?.value || null,
                isTwoWayEnabled: interfaceTwoWayEnabled,
                isHooterEnabled: interfacePanelEnableHooter,
                CheckInternalHooter: interfaceInternalHooter,
                CheckExternalHooter: interfaceExternalHooter,
                LiveRTSPURL: liveStreamURL == null ? "" : liveStreamURL,
                PlaybackRTSPURL: playbackStreamURL == null ? "" : playbackStreamURL,
                CheckPlaybackUTCTime: playbackTimeStampsToUTCEnabled,
                CheckPlaybackLongTime: playbackLongDateFormatEnabled,
                // EntityTypeID: EntityTypeIDCheck,
                EntityTypeID: deviceTypeId,
                TimeZoneID: interfaceTimeZoneId,
                OrganizationMasterID: user.OrganizationMasterID.toString(),
                UpdatedateTime: "",
                UserId: localStorage.getItem("UserID"),
                Communicationport: communicationPort || 8000,
                InternetProtocolPort: httpPort || 80,
                SerialNo: SerialNo?.toString().trim(),
                UserID: localStorage.getItem("UserID") || user?.Id.toString()
            };
            updateInterfaceDetails(updateInterfaceUAPIObj).then((resp) => {
                if (resp.Status === "success") {
                    let objInterface = {
                        InterfaceId: id,
                        InterfaceName: interfaceName,
                        InterfacetypeId: tempInterfaceType[0].InterfacetypeId,
                        InterfacesubtypeId: tempInterfaceSubType[0].InterfacesubtypeId,
                        InterfaceIP: interfaceIP,
                        InterfacePort: interfacePort,
                        UserName: interfaceUsername,
                        Password: interfacePassword,
                        siteid: filterValues.Site?.[0]?.value || null,
                        Interfacetypename: interfaceType,
                        Interfacesubtypename: interfaceSubType,
                        UserId: localStorage.getItem("UserID") || UserId,
                        IsTwoWayEnabled: interfaceTwoWayEnabled,
                        CheckInternalHooter: interfaceInternalHooter,
                        CheckExternalHooter: interfaceExternalHooter,
                        IsHooterEnabled: interfacePanelEnableHooter,
                        // "IsTwoWayEnabled": interfaceTwoWayEnabled,
                        CheckPlaybackUTCTime: playbackTimeStampsToUTCEnabled,
                        CheckPlaybackLongTime: playbackLongDateFormatEnabled,
                        LiveRTSPURL: liveStreamURL,
                        PlaybackRTSPURL: playbackStreamURL,
                        EntityTypeID: deviceTypeId, //entitySubType,
                        CCTVType: entityValue,
                        TimeZoneId: interfaceTimeZoneId,
                        deviceTypeId: deviceTypeId,
                        communicationPortInterface: communicationPort || 8000,
                        httpPortInterface: httpPort || 80,
                        SerialNo:SerialNo,
                        UserID: localStorage.getItem("UserID") || UserId,
                    };
                    setSelectedInterface(objInterface);
                    setButtonDisable(false);
                    fetchFilters();
                    handleApplyFilters();
                    SuccessToast(resp.Message);
                   // setIsInterfaceEdit(false);
                } else {
                    ErrorToast(resp.Message);
                    setButtonDisable(false);
                }
            });
        }
    };


    return (
        <div className="SiteMainContainer SiteTableMainDiv p-2">
            <h5>{selectedRow == null ? 'Add interface' : 'Edit interface'}</h5>
            {/* Add your form components here */}
            <div className='SiteFormAdditionForm'>
                <form style={{ width: "100%" }}>
                    <div className="site-form">
                        <div className="inputMainContainer w40dot75rem">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Interface Name*</label>
                                <input
                                    {...register("InterfaceName")}
                                    className="inputType"
                                    disabled={!isInterfaceEdit}
                                    placeholder="Enter Interface Name*"
                                    onKeyPress={(e) => {
                                        onSpecialChangeOnly(e)
                                        setInterfaceError('')
                                    }}
                                    onChange={() => { setInterfaceError('') }}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {interfaceError} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>System*</label>
                                <select
                                    {...register("InterfaceType")}
                                    disabled={selectedInterface.InterfaceId != 0 ? true : false}
                                    className="inputType ArrowSelectClass"
                                    onChange={(e) => {
                                        if (e.target.value == "Mobile") {
                                            setMobileDisplay(true)
                                        } else {
                                            setMobileDisplay(false)
                                        }
                                        interfaceSubTypeHandler(e)
                                        interfaceForDeviceTypeHandler(e)
                                        setInterfaceTypeError('')
                                        setValue("EntityTypeID", 0)
                                        setValue("CheckExternalHooter", 0);
                                        setValue("CheckInternalHooter", 0);
                                        setValue("IsHooterEnabled", 0);
                                        setValue("InterfaceTwoWayEnabled", 0)
                                    }}
                                >
                                    <option key="0" disabled={false} value="0" id="0">Select System*</option>
                                    {interfaceTypeData &&
                                        interfaceTypeData.map((val) => (
                                            <option
                                                value={val.Interfacetypename} key={val.InterfacetypeId}
                                                id={val.InterfacetypeId}>
                                                {val.Interfacetypename}
                                            </option>
                                        ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span> {interfaceTypeError} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Brand*</label>
                                <select
                                    {...register("InterfaceSubType")}
                                    disabled={selectedInterface.InterfaceId != 0 ? true : false}
                                    className="inputType ArrowSelectClass"
                                    onChange={(e) => {
                                        setValue("EntityTypeID", 0)
                                        setInterfaceSubtypeError('')
                                        if (e.target.value == "Unknown") {
                                            setDisplayLivePlaybackfield(true)
                                            setEnableHooter(false)
                                            setDisplayTwoWay(false)
                                            setDisplayCamera(false)
                                        } else if (getValues("InterfaceType") == "Alarm Panel") {
                                            setDisplayTwoWay(false);
                                            setEnableHooter(true);
                                            setDisplayLivePlaybackfield(false);
                                        }
                                        else if (getValues("InterfaceType") == "ACS" || getValues("InterfaceType") == "RTU" || getValues("InterfaceType") == "Fire Panel") {
                                            setDisplayLivePlaybackfield(false)
                                            setEnableHooter(false)
                                            setDisplayTwoWay(false)
                                            setDisplayCamera(false)
                                        }
                                        else {
                                            setDisplayLivePlaybackfield(false)
                                            setEnableHooter(false)
                                            setDisplayTwoWay(true)
                                            setDisplayCamera(false);
                                            setValue("IsHooterEnabled", 0);
                                            setValue("InterfaceTwoWayEnabled", 0)

                                        }
                                    }}
                                >
                                    <option key="0" disabled={false} value="0" id="0">Select Brand*</option>
                                    {interfaceSubTypeData &&
                                        interfaceSubTypeData.map((val) => (
                                            <option
                                                value={val.Interfacesubtypename}
                                                key={val.InterfacesubtypeId}
                                                id={val.InterfacesubtypeId}
                                            >
                                                {val.Interfacesubtypename}
                                            </option>
                                        ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span> {interfaceSubtypeError} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Interface*</label>
                                <select
                                    {...register("deviceTypeId")}
                                    disabled={selectedInterface.InterfaceId != 0 ? true : false}
                                    defaultValue={selectedInterface.deviceTypeId}
                                    className="inputType ArrowSelectClass"
                                    placeholder="Interface*"
                                    onChange={(e) => {
                                        setInterfaceDeviceTypeError('')
                                        if (getValues("InterfaceSubType") == "Unknown") {
                                            setDisplayCamera(false)
                                            setEnableHooter(false)
                                            setParentPanelIsEnablingHooter(false)
                                            setParentIsEnablingInternalHooter(false)
                                            setParentIsEnablingExternalHooter(false);
                                        } else {
                                            if (e.target.selectedOptions[0].text == "Camera") {
                                                setDisplayCamera(true)
                                                setEnableHooter(false)
                                                setParentPanelIsEnablingHooter(false);
                                            } else if (e.target.selectedOptions[0].text.includes("ACS") || e.target.selectedOptions[0].text.includes("RTU") || e.target.selectedOptions[0].text.includes("Fire Panel")) {
                                                setDisplayCamera(false)
                                                setEnableHooter(false)
                                                setParentIsEnablingInternalHooter(false)
                                                setParentIsEnablingExternalHooter(false)
                                                setValue("CheckExternalHooter", 0);
                                                setValue("CheckInternalHooter", 0);
                                                setValue("IsHooterEnabled", 0);
                                                setValue("InterfaceTwoWayEnabled", 0)
                                            }
                                            else {
                                                setDisplayCamera(false)
                                                setEnableHooter(true)
                                                setParentIsEnablingInternalHooter(false)
                                                setParentIsEnablingExternalHooter(false)
                                                setValue("CheckExternalHooter", 0);
                                                setValue("CheckInternalHooter", 0);
                                                setValue("IsHooterEnabled", 0);
                                                setValue("InterfaceTwoWayEnabled", 0)
                                            }
                                        }
                                        setValue("deviceTypeId", e.target.value)
                                    }}
                                >
                                    <option key="0" disabled={false} value="0" id="0">Select Interface*</option>
                                    {deviceTypeDataForInterface &&
                                        deviceTypeDataForInterface.map((val) => (
                                            <option
                                                value={val.DeviceTypeID} key={val.DeviceTypeID}
                                                id={val.DeviceTypeID}>
                                                {val.DeviceType}
                                            </option>
                                        ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span> {interfaceDeviceTypeError} </span></p>
                            </div>
                        </div>
                        {
                            !mobileDisplay
                                ?
                                <>
                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Interface IP*</label>
                                            <input
                                                {...register("InterfaceIP")}
                                                disabled={!isInterfaceEdit}
                                                className="inputType"
                                                placeholder="Enter Interface IP*"
                                                onKeyPress={(e) => {
                                                    onNumberOnlyChange2(e);
                                                    setInterfaceIPError('')
                                                }}
                                                onChange={() => setInterfaceIPError('')}
                                            />
                                            <p className="Error_P" style={{ float: "left" }}><span> {interfaceIPError} </span></p>
                                        </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Interface Port*</label>
                                            <input
                                                {...register("InterfacePort")}
                                                disabled={!isInterfaceEdit}
                                                className="inputType"
                                                placeholder="Enter Interface Port*"
                                                onKeyPress={(e) => {
                                                    onNumberOnlyChange(e);
                                                    setInterfacePortError('')
                                                }}
                                            />
                                            <p className="Error_P" style={{ float: "left" }}><span> {interfacePortError} </span></p>
                                        </div>
                                    </div>
                                    {
                                        displayEntity
                                            ?
                                            <>
                                                <div className="inputMainContainer w40dot75rem mt35">
                                                    <div className="inputTypeLabelContainer">
                                                        <label className='formFieldLabels'>Communication Port*</label>
                                                        <input
                                                            {...register("communicationPortInterface")}
                                                            disabled={!isInterfaceEdit}
                                                            className="inputType"
                                                            placeholder="Enter Communication Port* e.g. 8080"
                                                            onKeyPress={(e) => {
                                                                onNumberOnlyChange(e);
                                                                setCommunicationPortError('')
                                                            }}
                                                            onChange={() => setCommunicationPortError('')}
                                                            defaultValue={selectedInterface.communicationPortInterface}
                                                        />
                                                        <p className="Error_P" style={{ float: "left" }}><span> {communicationPortError} </span></p>
                                                    </div>
                                                </div>
                                                <div className="inputMainContainer w40dot75rem mt35">
                                                    <div className="inputTypeLabelContainer">
                                                        <label className='formFieldLabels'>HTTP Port*</label>
                                                        <input
                                                            {...register("httpPortInterface")}
                                                            className="inputType"
                                                            disabled={!isInterfaceEdit}
                                                            placeholder="Enter HTTP Port* e.g. 443"
                                                            onKeyPress={(e) => {
                                                                onNumberOnlyChange(e);
                                                                setHttpPotError('')
                                                            }}
                                                            onChange={() => setHttpPotError('')}
                                                            defaultValue={selectedInterface.httpPortInterface}
                                                        />
                                                        <p className="Error_P" style={{ float: "left" }}><span> {httpPortError} </span></p>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            null
                                    }
                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Interface Username*</label>
                                            <input
                                                {...register("InterfaceUsername")}
                                                className="inputType"
                                                disabled={!isInterfaceEdit}
                                                placeholder="Enter Interface Username*"
                                                onChange={() => setInterfaceUserError('')}
                                            />
                                            <p className="Error_P" style={{ float: "left" }}><span> {interfaceUserError} </span></p>
                                        </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Interface Password*</label>
                                            <input
                                                {...register("InterfacePassword")}
                                                className="inputType"
                                                disabled={!isInterfaceEdit}
                                                placeholder="Enter Interface Password*"
                                                onChange={() => setInterfacePasswardError('')}
                                            />
                                            <p className="Error_P" style={{ float: "left" }}><span> {interfacePasswardError} </span></p>
                                        </div>
                                    </div>

                                </>
                                :
                                null
                        }

                        {
                            MULTI_TIME_ZONE
                                ?
                                <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Timezone*</label>
                                        <select
                                            {...register("TimeZoneId")}
                                            disabled={!isInterfaceEdit}
                                            className="inputType ArrowSelectClass"
                                            onChange={(e) => {
                                                setValue("TimeZoneId", e.target.value)
                                                setInterfaceTimeZoneError('')
                                            }}
                                        >
                                            <option key="0" disabled={false} value="0" id="0">Select timezone*</option>
                                            {timezone &&
                                                timezone.map((val) => (
                                                    <option
                                                        value={val.TimeZoneId} key={val.TimeZoneId}
                                                        id={val.Abbreviation}>
                                                        {val.Abbreviation} (UTC{val.Shift.slice(0, -3)}) {val.Fullname}
                                                    </option>
                                                ))}
                                        </select>
                                        <p className="Error_P" style={{ float: "left" }}><span> {interfaceTimeZoneError} </span></p>
                                    </div>
                                </div>
                                :
                                null
                        }
                        <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Serial No</label>
                                            <input
                                                {...register("SerialNo")}
                                                className="inputType"
                                                disabled={!isInterfaceEdit}
                                                placeholder="Enter Serial No e.g. MH78UY"
                                                onKeyPress={(e) => {
                                        onSpecialChangeOnly(e)
                                        //setSerialNoError('')
                                    }}
                                               // onChange={() => setSerialNoError('')}
                                            />
                                            {/* <p className="Error_P" style={{ float: "left" }}><span> {serialNoError} </span></p> */}
                                        </div>
                                    </div>

                        {
                            !HIDE_STUFF
                                ?
                                displayLivePlaybackfield ?
                                    <>
                                        <div className="inputMainContainer w40dot75rem mt35">
                                            <div className="inputTypeLabelContainer">
                                                <label className='formFieldLabels'>Live Stream Format</label>
                                                <MentionsInput
                                                    {...register("LiveRTSPURL")}
                                                    disabled={!isInterfaceEdit}
                                                    placeholder="Enter live stream URL format"
                                                    className="inputType long-value-input"
                                                    style={{ marginLeft: "18px" }}
                                                    singleLine
                                                    value={rtspValue}
                                                    onChange={(e, newValue, newPlainTextValue) => {
                                                        setRtspValue(e.target.value)
                                                        setRtspValueEntered(newPlainTextValue)
                                                        setLiveStreamFormatError('')
                                                    }}
                                                >
                                                    <Mention
                                                        data={RTSP}
                                                        markup="{__display__}"
                                                        trigger={/(@([^@]*))$/}
                                                    />
                                                </MentionsInput>
                                                <p className="Error_P" style={{ float: "left" }}><span>{liveStreamFormatError}</span></p>
                                            </div>
                                        </div>

                                        <div className="inputMainContainer w40dot75rem mt35">
                                            <div className="inputTypeLabelContainer">
                                                <label className='formFieldLabels'>Playback Stream Format</label>
                                                <MentionsInput
                                                    {...register("PlaybackRTSPURL")}
                                                    disabled={!isInterfaceEdit}
                                                    placeholder="Enter playback URL format"
                                                    className="inputType long-value-input"
                                                    style={{ marginLeft: "18px" }}
                                                    singleLine
                                                    value={playbackValue}
                                                    onChange={(e, newValue, newPlainTextValue) => {
                                                        setPlaybackValue(e.target.value)
                                                        setPlaybackValueEntered(newPlainTextValue)
                                                        setPlaybackStreamFormatError('')
                                                    }}
                                                >
                                                    <Mention
                                                        data={PLAYBACK}
                                                        markup="{__display__}"
                                                        trigger={/(@([^@]*))$/}
                                                        style={{ border: "0px impotant" }}
                                                    />
                                                </MentionsInput>
                                                <p className="Error_P" style={{ float: "left" }}><span>{playbackStreamFormatError}</span></p>
                                            </div>
                                        </div>

                                        <div className="inputMainContainer w40dot75rem mt35">
                                            <div className="inputTypeLabelContainer">
                                                <label className='formFieldLabels'>UTC Conversion</label>
                                                <div className="onlyforEnableCheckbox">
                                                    <input className="checkbox_custom"
                                                        type="checkbox"
                                                        disabled={!isInterfaceEdit}
                                                        {...register("PlaybackTimeStampsToUTC")}
                                                        onChange={(e) => {
                                                            setValue("PlaybackTimeStampsToUTC", Number(e.target.checked))
                                                            setParentIsEnablingPlaybackTimeStampsToUTC(e.target.checked);
                                                        }}
                                                        defaultValue={Number(selectedInterface.CheckPlaybackUTCTime)}
                                                    />
                                                    <label className="mb-0"
                                                        onClick={() => {
                                                            if (!isInterfaceEdit) {
                                                                return;
                                                            }
                                                            getValues("PlaybackTimeStampsToUTC")
                                                            if (parentIsEnablingPlaybackTimeStampsToUTC) {
                                                                setValue("PlaybackTimeStampsToUTC", 0)
                                                                setParentIsEnablingPlaybackTimeStampsToUTC(false);
                                                            } else {
                                                                setValue("PlaybackTimeStampsToUTC", 1)
                                                                setParentIsEnablingPlaybackTimeStampsToUTC(true);
                                                            }
                                                        }}
                                                    >
                                                        Playback Timestamps to UTC
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="SiteTextBox SiteNameText" style={{ display: "none", height: "55px" }}>
                                            <div className="onlyforEnableCheckbox">
                                                <input
                                                    className="checkbox_custom"
                                                    type="checkbox"
                                                    disabled={!isInterfaceEdit}
                                                    {...register("PlaybackLongDateFormat")}
                                                    onChange={(e) => {
                                                        setValue("PlaybackLongDateFormat", Number(e.target.checked))
                                                        setParentIsEnablingPlaybackLongDateFormat(e.target.checked);
                                                    }}
                                                    defaultValue={Number(selectedInterface.CheckPlaybackLongTime)}
                                                />
                                                <label className="mb-0"
                                                    onClick={(e) => {
                                                        if (!isInterfaceEdit) {
                                                            return;
                                                        }
                                                        getValues("PlaybackLongDateFormat")
                                                        if (parentIsEnablingPlaybackLongDateFormat) {
                                                            setValue("PlaybackLongDateFormat", 0)
                                                            setParentIsEnablingPlaybackLongDateFormat(false);
                                                        } else {
                                                            setValue("PlaybackLongDateFormat", 1)
                                                            setParentIsEnablingPlaybackLongDateFormat(true);
                                                        }
                                                    }}
                                                >
                                                    Playback Long Date Format
                                                </label>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    null
                                :
                                null
                        }

                        {
                            displayTwoWay && !mobileDisplay
                                ?
                                <>
                                    <div className="inputMainContainer w40dot75rem mt30">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Two Way Communication</label>
                                            <div
                                                className="onlyforEnableCheckbox"
                                            >
                                                <input
                                                    className="checkbox_custom"
                                                    type="checkbox"
                                                    disabled={!isInterfaceEdit}
                                                    {...register("InterfaceTwoWayEnabled")}
                                                    onChange={(e) => {
                                                        setValue("InterfaceTwoWayEnabled", Number(e.target.checked))
                                                        if (Number(e.target.checked)) {
                                                            setParentIsEnablingTwoWayInterface(true);
                                                        } else {
                                                            setParentIsEnablingTwoWayInterface(false);
                                                        }
                                                    }}
                                                    defaultValue={Number(selectedInterface.IsTwoWayEnabled)}
                                                />
                                                <label className="mb-0"
                                                    onClick={() => {
                                                        if (!isInterfaceEdit) {
                                                            return;
                                                        }
                                                        getValues("InterfaceTwoWayEnabled")
                                                        if (parentIsEnablingTwoWayInterface) {
                                                            setValue("InterfaceTwoWayEnabled", 0)
                                                            setParentIsEnablingTwoWayInterface(false);
                                                        } else {
                                                            setValue("InterfaceTwoWayEnabled", 1)
                                                            setParentIsEnablingTwoWayInterface(true);
                                                        }
                                                    }}
                                                >
                                                    Two Way Communication Available
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </>
                                :
                                null
                        }

                        {
                            !HIDE_STUFF
                                ?
                                displayCamera
                                    ?
                                    <div className="inputMainContainer w40dot75rem">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Enable Hooter Types</label>
                                            <div className='mt-1 signTypeCheckboxLabels'>
                                                <div className="SiteTextBox SiteNameText mt-0">
                                                    <div className="onlyforEnableCheckbox ml-0">
                                                        <input
                                                            className="checkbox_custom"
                                                            type="checkbox"
                                                            disabled={!isInterfaceEdit}
                                                            {...register("CheckInternalHooter")}
                                                            onChange={(e) => {
                                                                setValue("CheckInternalHooter", Number(e.target.checked))
                                                                setParentIsEnablingInternalHooter(e.target.checked);
                                                                if (e.target.checked) {
                                                                    setValue("CheckExternalHooter", 0);
                                                                    setParentIsEnablingExternalHooter(false);
                                                                }
                                                            }}

                                                            defaultValue={Number(selectedInterface.CheckInternalHooter)}

                                                        />
                                                        <label className="mb-0"
                                                            onClick={() => {
                                                                if (!isInterfaceEdit) {
                                                                    return;
                                                                }
                                                                getValues("CheckInternalHooter")
                                                                if (parentIsEnablingInternalHooter) {
                                                                    setValue("CheckInternalHooter", 0)
                                                                    setParentIsEnablingInternalHooter(false);
                                                                } else {
                                                                    setValue("CheckInternalHooter", 1)
                                                                    setParentIsEnablingInternalHooter(true);
                                                                    setValue("CheckExternalHooter", 0);
                                                                    setParentIsEnablingExternalHooter(false);
                                                                }
                                                            }}
                                                        >
                                                            Enable Internal Hooter
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="SiteTextBox SiteNameText mt-0">
                                                    <div className="onlyforEnableCheckbox ml-0">
                                                        <input className="checkbox_custom"
                                                            type="checkbox"
                                                            disabled={!isInterfaceEdit}
                                                            {...register("CheckExternalHooter")}
                                                            onChange={(e) => {
                                                                setValue("CheckExternalHooter", Number(e.target.checked))
                                                                setParentIsEnablingExternalHooter(e.target.checked);
                                                                if (e.target.checked) {
                                                                    setValue("CheckInternalHooter", 0);
                                                                    setParentIsEnablingInternalHooter(false);
                                                                }
                                                            }}

                                                            defaultValue={Number(selectedInterface.CheckExternalHooter)}
                                                        />
                                                        <label className="mb-0"
                                                            onClick={() => {
                                                                if (!isInterfaceEdit) {
                                                                    return;
                                                                }
                                                                getValues("CheckExternalHooter")
                                                                if (parentIsEnablingExternalHooter) {
                                                                    setValue("CheckExternalHooter", 0)
                                                                    setParentIsEnablingExternalHooter(false);
                                                                } else {
                                                                    setValue("CheckExternalHooter", 1)
                                                                    setParentIsEnablingExternalHooter(true);
                                                                    setValue("CheckInternalHooter", 0);
                                                                    setParentIsEnablingInternalHooter(false);
                                                                }

                                                            }}
                                                        >
                                                            Enable External Hooter
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    null
                                :
                                null
                        }

                        {
                            !mobileDisplay
                                ?
                                enableHooter
                                    ?
                                    (
                                        <div className="inputMainContainer w40dot75rem mt30">
                                            <div className="inputTypeLabelContainer">
                                                <label className='formFieldLabels'>Enable/Disable Hooter</label>
                                                <div className="onlyforEnableCheckbox">
                                                    <input
                                                        className="checkbox_custom"
                                                        type="checkbox"
                                                        disabled={!isInterfaceEdit}
                                                        {...register("IsHooterEnabled")}
                                                        onChange={(e) => {
                                                            setValue("IsHooterEnabled", Number(e.target.checked))
                                                            setParentPanelIsEnablingHooter(e.target.checked);
                                                        }}
                                                        defaultValue={Number(selectedInterface.IsHooterEnabled)}

                                                    />
                                                    <label className="mb-0"
                                                        onClick={() => {
                                                            if (!isInterfaceEdit) {
                                                                return;
                                                            }
                                                            getValues("IsHooterEnabled")
                                                            if (parentPanelIsEnablingHooter) {
                                                                setValue("IsHooterEnabled", 0)
                                                                setParentPanelIsEnablingHooter(false);
                                                            } else {
                                                                setValue("IsHooterEnabled", 1)
                                                                setParentPanelIsEnablingHooter(true);
                                                            }
                                                        }}
                                                    >
                                                        Enable Hooter
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null
                                : null
                        }





                    </div>
                </form>
            </div>
            <div style={{ textAlign: "center" }}>
                <button className="DataAccessEdit" style={{ width: "100px" }}

                    onClick={handleSubmit((e) => onInterfaceFormSubmit(e, selectedInterface.InterfaceId, rtspValueEntered, playbackValueEntered))}
                >
                    <span className="ViewUpdate">Save</span>
                </button>
                <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => setShowAddSite(false)}>
                    <span className="ViewUpdate">Cancel</span>
                </button>
            </div>
        </div>
    )
}

export default InterfaceAdditionForm